import { IconButton, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useContext, useState } from 'react';
import useStatusBarStyles from './styles';
import StatusBarMenuIcon from 'components/StatusBarMenuIcon';

import { StatusBarWrapperContext } from 'components/StatusBarWrapper/context';
import { useTranslation } from 'react-i18next';
import { useUserTenantPreference } from 'kineticUtils/hooks';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';
import { MapContext } from 'components/maps/MapContext';
import { StatusBarPreference } from 'components/StatusBarWrapper/types';

const StatusBarMenu: React.FunctionComponent = () => {
  const classes = useStatusBarStyles();
  const { t } = useTranslation('common');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { activeStatusBar, setActiveStatusBar, isStatusBarOpen } = useContext(MapContext);
  const { statusBars } = useContext(StatusBarWrapperContext);

  const { setPreference } = useUserTenantPreference<StatusBarPreference>({
    key: PREFERENCE_KEYS.MAP_STATUS_BAR,
  });

  const open = Boolean(anchorEl);
  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (module: string) => {
    setPreference({ activeStatusBar: module, isStatusBarOpen });
    setActiveStatusBar(module);
    handleClose();
  };

  return (
    <div className={classes.fullSize}>
      <IconButton onClick={handleOpen}>
        <StatusBarMenuIcon module={activeStatusBar} className={classes.moduleIcon} />
        <ArrowDropDownIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {statusBars.map((module) => (
          <MenuItem key={`status-bar-menu-item-${module}`} onClick={() => handleSelect(module)}>
            <StatusBarMenuIcon module={module} className={classes.icon} />
            {t(module)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default StatusBarMenu;
